import { RoutesService, eLayoutType } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eThemeSharedRouteNames } from '@abp/ng.theme.shared';

export const APP_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.remove([eThemeSharedRouteNames.Administration]);
    routes.add([
      // Customer
      {
        path: '',
        name: '::Menu:customers',
        iconClass: 'team',
        requiredPolicy: 'Masters.Customers',
        order: 1,
      },
      // Vessel
      {
        path: '/pages/vessel',
        name: '::Menu:vessels',
        iconClass: 'crown',
        requiredPolicy: 'Masters.Vessels',
        order: 2,
      },
      // Vendor
      {
        path: '/pages/vendor',
        name: '::Menu:vendors',
        iconClass: 'deployment-unit',
        requiredPolicy: 'Masters.Vendors',
        order: 3,
      },
      {
        path: '',
        name: '::Menu:admin',
        iconClass: 'safety-certificate',
        layout: eLayoutType.application,
        order: 4,
      },
      {
        path: '',
        name: '::Menu:masterpages',
        iconClass: 'read',
        layout: eLayoutType.application,
        order: 5,
      },
      {
        path: '',
        name: 'Warehouse Masters',
        parentName: '::Menu:masterpages',
        iconClass: 'shop',
        layout: eLayoutType.application,
        order: 11,
      },
      {
        path: '',
        name: '::Menu:system',
        iconClass: 'laptop',
        layout: eLayoutType.application,
        order: 6,
      },
      {
        path: '',
        name: '::Menu:integrations',
        iconClass: 'plus',
        layout: eLayoutType.application,
        order: 7,
      },
      {
        path: '',
        name: '::Menu:mappings',
        iconClass: 'node-expand',
        layout: eLayoutType.application,
        order: 8,
      },
      {
        path: '',
        name: '::Menu:transactions',
        iconClass: 'profile',
        layout: eLayoutType.application,
        order: 9,
      },
      {
        path: '/pages/warehouse',
        name: '::Menu:warehouses',
        iconClass: 'shop',
        requiredPolicy: 'Warehouse.Warehouse',
        order: 10,
      },
    ]);
  };
}
